export default "__VITE_ASSET__CHqrVsk2__"